import React from 'react';

export default function DealTag() {
  return <p className="deal-tag">Deal</p>;
}
